import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const labelIcon: SxStyleFunc<boolean | undefined> = (checked) => ({
  opacity: checked ? 1 : 0.5,
});

export const loadingContainer: SxStyle = {
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: 1,
  padding: 0.5,
  // paddingBottom: 1,
};

export const checkboxItem: SxStyle = {
  cursor: 'pointer',
  height: (p) => p.spacing(4),
  '&:hover': {
    backgroundColor: 'grey.200',
    '& .only-button': {
      display: 'inline-flex',
    },
  },
};

export const selectAllLabel: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const onlyButton: SxStyle = {
  display: 'none',
  transition: 'all 0.2s ease',
};
